/* Classifies product photos so each sits nicely on the light, airy theme:
   cp-cut   = transparent cutout (floats with a soft shadow)
   cp-paper = white studio background (blends into a white tile)
   cp-photo = full-bleed photo (left as is) */
(function () {
  var SEL = '.card__media img, .product__media img, .global-media-settings img';
  function check(img) {
    var src = img.currentSrc || img.src;
    if (!src || img.dataset.cpChecked === src) return;
    img.dataset.cpChecked = src;
    var t = new Image();
    t.crossOrigin = 'anonymous';
    t.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = c.height = 16;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(t, 0, 0, 16, 16);
        var pts = [[0,0],[15,0],[0,15],[15,15],[8,0],[0,8],[15,8],[8,15]];
        var cut = 0, paper = 0;
        for (var i = 0; i < pts.length; i++) {
          var d = x.getImageData(pts[i][0], pts[i][1], 1, 1).data;
          if (d[3] < 40) cut++;
          else if (d[3] > 200 && d[0] > 230 && d[1] > 230 && d[2] > 230) paper++;
        }
        var m = img.closest('.media') || img.parentElement;
        m.classList.remove('cp-cut', 'cp-paper', 'cp-photo');
        m.classList.add(cut >= 5 ? 'cp-cut' : paper >= 6 ? 'cp-paper' : 'cp-photo');
      } catch (e) {}
    };
    t.src = src;
  }
  function run() { document.querySelectorAll(SEL).forEach(check); }
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG' && e.target.matches(SEL)) check(e.target); }, true);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
